import { Overlay } from '@angular/cdk/overlay';
import { DOCUMENT } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_SELECT_SCROLL_STRATEGY } from '@angular/material/select';
import { NavigationEnd, Router, RouterEvent } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subject, map } from 'rxjs';
import { distinctUntilChanged, filter, takeUntil } from 'rxjs/operators';
import { AppService } from './app.service';
import { scrollFactory } from './shared/functions/scroll-factory';

// TODO Check if onPush can be enabled
// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'osn-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [AppService, TranslateService, { provide: MAT_SELECT_SCROLL_STRATEGY, useFactory: scrollFactory, deps: [Overlay] }],
})
export class AppComponent implements OnInit, OnDestroy {
  public title = 'osn-cxb';
  public isLoading: boolean;
  public isIframe = window !== window.parent && !window.opener;

  public showMenuBar$: Observable<boolean>;

  private readonly destroyed$ = new Subject<void>();

  constructor(
    private readonly appService: AppService,
    private readonly cdr: ChangeDetectorRef,
    translate: TranslateService,
    @Inject(DOCUMENT) document: Document,
    private readonly router: Router
  ) {
    this.showMenuBar$ = this.router.events.pipe(
      filter((routerEvent: RouterEvent) => routerEvent instanceof NavigationEnd),
      map((routerEvent: NavigationEnd) => {
        return !routerEvent.url.startsWith('/select-tenant') && !routerEvent.urlAfterRedirects.startsWith('/select-tenant');
      })
    );

    document.dir = 'ltr';
    translate.setDefaultLang('en');
    translate.use('en');
  }

  public ngOnInit(): void {
    this.appService.isLoading$.pipe(distinctUntilChanged(), takeUntil(this.destroyed$)).subscribe((value) => {
      this.isLoading = value;
      this.cdr.detectChanges();
    });
  }

  public ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
